module.exports = __webpack_public_path__ + "static/media/download.a3a04f66.webp";